<div class="modal-header text-center">
   <h4 class="modal-title w-100 font-weight-bold">
      <i class="bi bi-person-plus-fill">Add user</i>
   </h4>
   <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="closeCreateUserModal('close')"></button>
</div>
<div>
   <form class="modal-xl modal-lg" [formGroup]="userForm" style="color: #757575;" (ngSubmit)="onSubmit()" autocomplete="off">
   <div class="modal-body">
      <div class="row">
         <div class="col-md-12 mb-4">
            <div class="form-group">
               <label for="first_name" class="form-label">First Name</label>
               <input type="text" class="form-control" id="first_name" 
                  [ngClass]="{'is-invalid': isFirstNameInvalid || isFirstNamePatternInvalid || isFirstNameLengthInvalid }"
                  formControlName="first_name" placeholder="Enter first name">
               <div *ngIf="isFirstNameInvalid"
                  class="invalid-tooltip">
                  The first name is required
               </div>
               <div *ngIf="isFirstNamePatternInvalid"
                  class="invalid-tooltip">
                  The first name contains invalid characters.
               </div>
               <div *ngIf="isFirstNameLengthInvalid"
                  class="invalid-tooltip">
                  The first name cannot exceed 50 characters.
               </div>
            </div>
         </div>
         <div class="col-md-12 mb-4">
            <div class=" form-group">
               <label for="other_name" class="form-label">Other name</label>
               <input type="text" class="form-control" id="other_name" 
                  [ngClass]="{'is-invalid': isOtherNameInvalid || isOtherNamePatternInvalid || isOtherNameLengthInvalid }"
                  formControlName="other_name" placeholder="Enter other name">
               <div *ngIf="isOtherNameInvalid"
                  class="invalid-tooltip">
                  The other name is required
               </div>
               <div *ngIf="isOtherNamePatternInvalid"
                  class="invalid-tooltip">
                  The othe name contains invalid characters.
               </div>
               <div *ngIf="isOtherNameLengthInvalid"
                  class="invalid-tooltip">
                  The other name cannot exceed 50 characters.
               </div>
            </div>
         </div>
         <div class="col-md-12  mb-4">
            <div class="form-group">
               <label for="last_name" class="form-label">Last name</label>
               <input type="text" class="form-control" id="last_name"
                  [ngClass]="{'is-invalid': isLastNameInvalid || isLastNamePatternInvalid || isLastNameLengthInvalid }"
                  formControlName="last_name" placeholder="Enter last name">
               <div *ngIf="isLastNameInvalid"
                  class="invalid-tooltip">
                  The last name is required
               </div>
               <div *ngIf="isLastNamePatternInvalid"
                  class="invalid-tooltip">
                  The last name contains invalid characters.
               </div>
               <div *ngIf="isLastNameLengthInvalid"
                  class="invalid-tooltip">
                  The last name cannot exceed 50 characters.
               </div>
            </div>
         </div>
         <div class="col-md-12  mb-4">
            <div class="  form-group">
               <label for="email_address" class="form-label">Email address</label>
               <input type="email" class="form-control" id="email"
                  [ngClass]="{'is-invalid': isEmailInvalid ||isEmailPatternInvalid || isEmailLengthInvalid }"
                  formControlName="last_name" placeholder="Enter last name">
               <div *ngIf="isEmailInvalid"
                  class="invalid-tooltip">
                  The email  is required
               </div>
               <div *ngIf="isEmailPatternInvalid"
                  class="invalid-tooltip">
                  The email contains invalid characters.
               </div>
               <div *ngIf="isEmailLengthInvalid"
                  class="invalid-tooltip">
                  The email cannot exceed 50 characters.
               </div>
            </div>
         </div>
         <div class="col-md-12 mb-4">
            <div class="   md-form form-group">
               <select class="form-control" (change)="onActive($event)">
                  <option value="1" style="color: red;">Active</option>
                  <option value="0">Not Active</option>
               </select>
            </div>
         </div>
         <div class="col-md-12  mb-4">
            <div class=" form-group">
               <ng-multiselect-dropdown
               multiselect placeholder="Select Roles"
               [settings]="dropdownSettings"
               [data]="allroles"
               label="Select Role:" 
               [(ngModel)]="selected"
               [options]="roleSelect"
               [ngModelOptions]="{standalone: false}"
               (onSelect)="onItemSelect($event)"
               (onSelectAll)="onSelectAll($event)"
               (onDeSelect)="onItemDeSelect($event)"
               formControlName="selectRole"
               [allowClear]="true"></ng-multiselect-dropdown>
            </div>
         </div>
         <div class="modal-footer d-flex justify-content-center"> 
            <button type="submit" class="btn btn-primary"
               [disabled]="!userForm.valid">
            Create
            </button>
         </div>
      </div>
   </div>
   </form>
</div>
  